import { ref } from 'vue'

export const previousRoute = ref(null)

export default defineNuxtPlugin(() => {
    const router = useRouter()

    router.beforeEach((to, from) => {

        previousRoute.value = from
    })
})
